import { FetchTreatmentDetailRequestPayload } from "@/data/payload/treatment/fetch-treatment-detail-request-payload";
import { TreatmentDetailEntity } from "@/domain/entity/treatment/treatment-info-entity";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { TreatmentState } from "@/utils/enum/treatment-state-enum";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchTreatmentDetailUsecase {
  //MARK:- Constructor
  constructor(private readonly treatmentRepo: TreatmentRepository) {}

  //MARK:- execute
  async execute(
    patientUuid: string,
    treatmentInfoUuid: string
  ): Promise<SATResult<TreatmentDetailEntity | null, SATError>> {
    const payload: FetchTreatmentDetailRequestPayload = { patientUuid, treatmentInfoUuid };
    const result = await this.treatmentRepo.fetchTreatmentDetail(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    // 치료가 취소되었으면 치료 상세 정보를 반환하지 않음
    if (result.value.stateSummary?.state !== TreatmentState.canceled) {
      return SATResult.success(result.value);
    } else {
      return SATResult.success(null);
    }
  }
}
